export default __webpack_public_path__ + "static/media/orange-logo.5cdb468f.svg";